export default __webpack_public_path__ + "img/0feba3e847d60adddd71e638edbde166.svg";